export function preloadAssets(scene) {

    // -------------------------
    // HeaderHomers
    // -------------------------
    scene.load.image(
        'homersLogo',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Brands/HomerTransparent-logo.png'
    );

    // -------------------------
    // timer/score icons
    // -------------------------
    scene.load.image(
        'clockIcon',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Timer_Icon/time.png'
    );

    scene.load.image(
        'scoreDonut',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Points_Icon/bitten-donut.png'
    );

    scene.load.image(
        'winRewardDonut',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Points_Icon/2quarters.png'
    );

    // -------------------------
    // Donuts
    // -------------------------
    scene.load.image(
        'purpleDonut',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/donut1.png'
    );

    scene.load.image(
        'pinkDonut',
        //'assets/phaser/DonutsFallGame/Donuts/pinkIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/donut2.png'
    );

    scene.load.image(
        'orangeDonut',
        //'assets/phaser/DonutsFallGame/Donuts/orangeIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/donut3.png'
    );

    scene.load.image(
        'lightBlueDonut',
        //'assets/phaser/DonutsFallGame/Donuts/lightBlueIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/donut4.png'
    );

    scene.load.image(
        'darkBlueDonut',
        //'assets/phaser/DonutsFallGame/Donuts/darkBlueIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/donut5.png'
    );

    scene.load.image(
        'tealSprinkledDonut',
        //'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/tealsprinkleddonut.png'
        'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/donut6.png'
    );

    // -------------------------
    // Donuts (homers)
    // -------------------------
    scene.load.image(
        'biscoff',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/biscoff.png'
    );

    scene.load.image(
        'cannoli',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/cannoli.png'
    );

    scene.load.image(
        'chocosprinkles',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/chocosprinkles.png'
    );

    scene.load.image(
        'cookiemonster',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/cookiemonster.png'
    );

    scene.load.image(
        'cremebrulee',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/cremebrulee.png'
    );

    scene.load.image(
        'dubai',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/dubai.png'
    );

    scene.load.image(
        'homers',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/homers.png'
    );

    scene.load.image(
        'lemoncrumbl',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/lemoncrumbl.png'
    );

    scene.load.image(
        'nutella',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/nutella.png'
    );

    scene.load.image(
        'oreo',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/oreo.png'
    );

    scene.load.image(
        'reeses',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/reeses.png'
    );

    scene.load.image(
        'smores',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/smores.png'
    );

    scene.load.image(
        'strawberrykiss',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/strawberrykiss.png'
    );

    scene.load.image(
        'sugar',
        //'assets/phaser/DonutsFallGame/Donuts/purpleIcingDonut.png'
        'assets/phaser/DonutsFallGame/Donuts/HomersImportedImages/sugar.png'
    );

    // -------------------------
    // Effects
    // -------------------------
    scene.load.image(
        'shine',
        'assets/phaser/DonutsFallGame/Donuts/glowEffect.png'
    );

    scene.load.spritesheet(
        'sparkleWhite',
        'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/sparling-spreadsheet-white.png',
        {
            frameWidth: 80,
            frameHeight: 80
        }
    );

    scene.load.spritesheet(
        'sparkleYellow',
        'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/sparling-spreadsheet-yellow.png',
        {
            frameWidth: 80,
            frameHeight: 80
        }
    );

    scene.load.spritesheet(
        'sparklePink',
        'assets/phaser/DonutsFallGame/Donuts/TramUpdatedImages/sparling-spreadsheet-pink.png',
        {
            frameWidth: 80,
            frameHeight: 80
        }
    );

    // -------------------------
    // Confettis
    // -------------------------
    scene.load.image(
        'confettiBlue',
        'assets/phaser/DonutsFallGame/Confettis/confettis-blue.png'
    );

    scene.load.image(
        'confettiBlue2',
        'assets/phaser/DonutsFallGame/Confettis/confettis-blue2.png'
    );

    scene.load.image(
        'confettiGreen',
        'assets/phaser/DonutsFallGame/Confettis/confettis-green.png'
    );

    scene.load.image(
        'confettiPink',
        'assets/phaser/DonutsFallGame/Confettis/confettis-pink.png'
    );

    scene.load.image(
        'confettiYellow',
        'assets/phaser/DonutsFallGame/Confettis/confettis-yellow.png'
    );

    // -------------------------
    // UI
    // -------------------------
    scene.load.image(
        'neonContainer',
        'assets/phaser/DonutsFallGame/UI_Menus/neonBox.png'
    );

    scene.load.image(
        'splashScreen',
        'assets/phaser/DonutsFallGame/UI_Menus/splashScreen.png'
    );

    scene.load.image(
        'closeButtonWhite',
        'assets/phaser/DonutsFallGame/UI_Menus/exitbtn_resize.png'
    );

    scene.load.image(
        'closeButton',
        'assets/phaser/DonutsFallGame/UI_Menus/exitbtn_resize_pink.png'
    );

    // -------------------------
    // Slice animations
    // -------------------------
    scene.load.spritesheet(
        'pinkDonutSlices',
        'assets/phaser/DonutsFallGame/Donuts/Unrealistic_look/pinkIcingDonut_ExtraPink_spreadsheet.png',
        {
            frameWidth: 105,
            frameHeight: 105
        }
    );

    scene.load.spritesheet(
        'blueDonutSlices',
        'assets/phaser/DonutsFallGame/Donuts/Unrealistic_look/blueIcingDonut_ExtraBlue_spreadsheet.png',
        {
            frameWidth: 105,
            frameHeight: 105
        }
    );

    scene.load.spritesheet(
        'purpleDonutSlices',
        'assets/phaser/DonutsFallGame/Donuts/Unrealistic_look/purpleIcingDonut_ExtraPurple_spreadsheet.png',
        {
            frameWidth: 105,
            frameHeight: 105
        }
    );

    scene.load.spritesheet(
        'tealDonutSlices',
        'assets/phaser/DonutsFallGame/Donuts/Unrealistic_look/tealIcingDonut_ExtraTeal_spreadsheet.png',
        {
            frameWidth: 105,
            frameHeight: 105
        }
    );

    scene.load.spritesheet(
        'yellowDonutSlices',
        'assets/phaser/DonutsFallGame/Donuts/Unrealistic_look/yellowIcingDonut_ExtraYellow_spreadsheet.png',
        {
            frameWidth: 105,
            frameHeight: 105
        }
    );
}